module.exports = __webpack_public_path__ + "static/4-85076d856143c79d689ded274faa776f.jpg";